import React, { Component } from 'react'
import { connect } from 'react-redux'

class ErrorCodes extends Component {
    renderIntegrationTool() {
        return null
    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Error Codes</b></span>

                <table style={{marginTop: '4vh'}}>
                    <th>Error Code</th>
                    <th>Description</th>

                    <tr>
                        <td>200</td>
                        <td>OK (there will be no value returned in the MCP error message)</td>
                    </tr>
                    <tr>
                        <td>500</td>
                        <td>Upstream error</td>
                    </tr>
                    <tr>
                        <td>1000</td>
                        <td>Invalid JSON format</td>
                    </tr>
                    <tr>
                        <td>1003</td>
                        <td>{"Invalid txnType detected: <invalid txnType> please enter PURCHASE or REFUND"}</td>
                    </tr>
                    <tr>
                        <td>1005</td>
                        <td>Invalid rateInquiryId-txnType combination.</td>
                    </tr>
                    <tr>
                        <td>1007</td>
                        <td>Warning: at least one of cardHolderCurrency or merchantSettlementCurrency must be non-zero.</td>
                    </tr>
                    <tr>
                        <td>1008</td>
                        <td>Card-holder amount must be non-zero.</td>
                    </tr>
                    <tr>
                        <td>1009</td>
                        <td>Negative amounts detected</td>
                    </tr>
                    <tr>
                        <td>1010</td>
                        <td>{"Unsupported cardholder currency detected: <unsupported currency>"}</td>
                    </tr>
                    <tr>
                        <td>1015</td>
                        <td>invalid rateInquiryId</td>
                    </tr>
                    <tr>
                        <td>1016</td>
                        <td>Unsupported merchant id</td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, ecrNumber } = state.mcp.main.config;
    return { mode, storeId, apiToken, ecrNumber, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {})(ErrorCodes)
